import { TooltipNew } from 'ui';
import { WarningYellowIcon } from 'ui/icons';

export const ArchivedRelationMarker = ({ relation }: { relation: 'asset' | 'bank' | 'broker' }) => (
  <TooltipNew
    text={`This ${relation} has been archived.`}
    place="top"
    showDelay={200}
    hideDelay={300}
  >
    <img src={WarningYellowIcon} alt={`Archived ${relation}`} className="h-4 w-4 min-w-4" />
  </TooltipNew>
);
